export default __webpack_public_path__ + "static/media/category3.23d48553.png";